export const ROLE_PERMISSION_ROLE_KEYS = [
  "DIRECTOR",
  "PRINCIPAL",
  "VICE_PRINCIPAL",
  "RECEPTION",
];

export const ROLE_PERMISSION_LABELS = {
  DIRECTOR: "Director",
  PRINCIPAL: "Principal",
  VICE_PRINCIPAL: "Vice Principal",
  RECEPTION: "Reception",
};

export const DEFAULT_ROLE_SCOPE = { type: "WHOLE_SCHOOL" };

export const can = (permissionKey, rolePermissions = null) => {
  if (Array.isArray(permissionKey))
    return permissionKey.some((key) => can(key, rolePermissions));
  if (!permissionKey) return false;
  if (
    rolePermissions?.authorityType === "SYSTEM_SUPERADMIN" &&
    ["settings.roles_permissions", "settings.users"].includes(permissionKey)
  )
    return true;
  return rolePermissions?.permissions?.[permissionKey] === true;
};

export const canExplicit = (permissionKey, rolePermissions = null) => {
  if (!permissionKey) return false;
  return Boolean(rolePermissions?.permissions?.[permissionKey]);
};

export const canFromSession = (sessionOrState = {}, permissionKey = "") =>
  can(
    permissionKey,
    sessionOrState?.rolePermissions ||
      sessionOrState?.me?.rolePermissions ||
      null,
  );

export const normalizeRolePermissionRoleKey = (value = "") => {
  const token = String(value || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_");
  if (token === "VP" || token === "VICEPRINCIPAL" || token === "VICE_PRINCIPAL")
    return "VICE_PRINCIPAL";
  if (token === "PRINCIPAL") return "PRINCIPAL";
  if (
    token === "RECEPTION" ||
    token === "RECEPTIONIST" ||
    token === "FRONT_DESK"
  )
    return "RECEPTION";
  return token;
};
